<template>
  <a-locale-provider :locale="locale">
    <div class="page-news-list container">
      <a-breadcrumb class="cell-header" separator="" style="margin-bottom: 30px">
        <a-breadcrumb-item>当前位置</a-breadcrumb-item>
        <a-breadcrumb-separator>:</a-breadcrumb-separator>
        <a-breadcrumb-item>
          <a href="/" title="首页">首页</a>
        </a-breadcrumb-item>
          <a-breadcrumb-separator>>></a-breadcrumb-separator>
        <a-breadcrumb-item>
          新闻公告
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="cell-body">
        <a-tabs type="card" @change="onSelectType" :active-key="type">
          <a-tab-pane :tab="thing.title" v-for="thing in typeList" :key="thing.type">
            <div class="spin-container" v-if="loading">
              <a-spin ></a-spin>
            </div>
            <ul v-else>
              <template v-for="(item,index) in list">
                <li :key="item.pageId" >
                  <router-link :to="`/news/${item.pageId}`">
                    <span class="label">{{ item.title }} <span v-if="isNew(item.time)" class="new-flag">NEW</span></span>
                    <span class="time">{{ item.time }}</span>
                  </router-link>
                  <p class="summary">{{ item.summary }}</p>
                </li>
                <hr class="hr-style" v-if="index !== list.length - 1" :key="item._id" >
              </template>
            </ul>
            <div v-if="!loading && !list.length" class="empty">
              暂无{{thing.label}}内容
            </div>
          </a-tab-pane>
        </a-tabs>

      </div>
      <div class="cell-footer">
        <a-pagination showSizeChanger @showSizeChange="onShowSizeChange" @change="onChange" v-model="pageNum" :page-size="pageSize" :total="total" :show-total="total => `共${pageNum}页 ${total}条记录`"/>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { fetchNews } from '@/apis/content'
import moment from 'moment'
import queryString from 'query-string'
import './index'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 20,
      total: 0,
      list: [],
      content: '',
      page: {},
      loading: true,
      locale: zhCN,
      type: '',
      typeList: []
    }
  },
  async created () {
    try {
      const { types } = await window.__MICRO_ROOT__?.cms.getPageData()
      const typeList = this.typeList = types?.list || []
      const query = queryString.parse(location.search)
      this.type = query.type ? query.type : typeList[0]?.type
      this.$nextTick(() => {
        this.fetch()
      })
    } catch (err) {
      window.__MICRO_ROOT__?.router.replace({
        pathname: '/'
      })
      console.error(err)
    }
  },
  methods: {
    fetch () {
      const { pageNum, pageSize, type } = this
      this.loading = true

      fetchNews({
        pageNum,
        pageSize,
        type,
        channel: 'pc'
      }).then(data => {
        const { page, pageSize, total, list } = data

        this.pageNum = page || 1
        this.pageSize = pageSize || 20
        this.total = total || 0
        this.list = list
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    onShowSizeChange (current, pageSize) {
      this.pageNum = 1
      this.pageSize = pageSize
      this.$nextTick(() => {
        this.fetch()
      })
    },
    onChange (current) {
      this.pageNum = current
      this.$nextTick(() => {
        this.fetch()
      })
    },
    onSelectType (key) {
      this.pageNum = 1
      this.type = key
      this.fetch()
    },
    isNew (itemDate) {
      let flag = false
      if (itemDate && Number(moment(new Date()).diff(moment(itemDate), 'week')) === 0) {
        flag = true
      }
      return flag
    }
  }
}
</script>
